import { Component } from "react";
import { withRouter } from "../../utils/withRouter";
import { Layout, Card, Button, Switch, Menu, Popconfirm, message } from "antd";
import {
  HomeOutlined,
  AppstoreOutlined,
  ArrowLeftOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import mainStyles from "../../styles/Main.module.css";
import {
  getBrickCollection,
  updateBrickCollection,
  deleteBrickCollection,
} from "../../utils";
import BricksList from "./BricksList";
import EditNameModal from "./EditNameModal";
import UploadThumbnail from "./UploadThumbnail";
import AccountMenu from "../../fragments/AccountMenu/AccountMenu";
import { SessionContext } from "../../session/SessionContext";
import { isOperator } from "../../session/access";

const { Header, Sider, Content } = Layout;

interface State {
  brickCollection: any | null;
  editNameModal: boolean;
  updating: boolean;
}

class Dashboard extends Component<any, State> {
  static contextType = SessionContext;
  declare context: React.ContextType<typeof SessionContext>;

  state: State = {
    brickCollection: null,
    editNameModal: false,
    updating: false,
  };

  componentDidMount() {
    this.fetchBrickCollection();
  }

  fetchBrickCollection = async () => {
    const brickCollection = await getBrickCollection(
      this.props.match.params.organizationId,
      this.props.match.params.collectionId
    );
    this.setState({
      brickCollection,
    });
  };

  handleDelete = async () => {
    const { organizationId, collectionId } = this.props.match.params;
    try {
      await deleteBrickCollection(organizationId, collectionId);
      this.props.history.push(`/${organizationId}`);
    } catch (e) {
      message.error((e as Error).message);
    }
  };

  handleVisibilityChange = async (checked: boolean) => {
    this.setState({ updating: true });
    await updateBrickCollection(
      this.props.match.params.organizationId,
      this.props.match.params.collectionId,
      { hidden: !checked }
    );
    this.setState((prevState) => ({
      updating: false,
      brickCollection: {
        ...prevState.brickCollection,
        hidden: !checked,
      },
    }));
  };

  render() {
    const { brickCollection, editNameModal } = this.state;
    const { organizationId, collectionId } = this.props.match.params;
    const operator = isOperator(this.context.user);
    return (
      <Layout className={mainStyles.main}>
        <Sider className={mainStyles.mainSider} width={200}>
          <div className={mainStyles.siderLogo}>Brixture</div>
          <Menu
            theme="dark"
            mode="inline"
            selectedKeys={["collection"]}
            items={[
              ...(operator
                ? [
                    {
                      key: "home",
                      icon: <HomeOutlined />,
                      label: "Organizations",
                      onClick: () => this.props.history.push("/"),
                    },
                  ]
                : []),
              {
                key: "collections",
                icon: <AppstoreOutlined />,
                label: "Collections",
                onClick: () => this.props.history.push(`/${organizationId}`),
              },
              {
                key: "collection",
                icon: <EditOutlined />,
                label: brickCollection?.name ?? "Collection",
              },
            ]}
          />
        </Sider>
        <Layout>
          <Header className={mainStyles.mainHeader}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={() => this.props.history.push(`/${organizationId}`)}
              />
              <span className={mainStyles.headerTitle}>
                {brickCollection?.name ?? "Collection"}
              </span>
            </div>
            <div className={mainStyles.headerActions}>
              <Button
                icon={<EditOutlined />}
                onClick={() => this.setState({ editNameModal: true })}
              >
                Wijzig naam
              </Button>
              <Popconfirm
                title="Deze collectie verwijderen?"
                description="De collectie verdwijnt ook uit de widget."
                okText="Verwijderen"
                okButtonProps={{ danger: true }}
                onConfirm={this.handleDelete}
              >
                <Button danger icon={<DeleteOutlined />}>
                  Verwijderen
                </Button>
              </Popconfirm>
              <AccountMenu />
            </div>
          </Header>
          <Content className={mainStyles.container}>
            <Card loading={brickCollection == null}>
              <div style={{ marginBottom: 16 }}>
                <UploadThumbnail
                  brickCollection={brickCollection ?? {}}
                  onUpdate={(newCollection) =>
                    this.setState({ brickCollection: newCollection })
                  }
                />
              </div>
              <div>
                <Switch
                  checked={!brickCollection?.hidden}
                  onChange={this.handleVisibilityChange}
                  style={{ marginRight: 8 }}
                />
                Zichtbaar
              </div>
            </Card>
            <div style={{ marginTop: 16 }}>
              <BricksList
                brickCollection={brickCollection}
                onChange={this.fetchBrickCollection}
              />
            </div>
          </Content>
        </Layout>
        <EditNameModal
          organization={organizationId}
          id={collectionId}
          open={editNameModal}
          onClose={() => {
            this.fetchBrickCollection();
            this.setState({ editNameModal: false });
          }}
        />
      </Layout>
    );
  }
}

export default withRouter(Dashboard);
